// src/pages/email/EmailComposerPage.jsx
import React from 'react';
import EmailComposer from '../../components/email/EmailComposer';
import { useNavigate, useLocation } from 'react-router-dom';

const EmailComposerPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const emailData = location.state?.emailData;
  const mode = location.state?.mode || 'compose'; // 'forward', 'edit', or 'compose'
  const templateId = location.state?.templateId;
  const handleClose = () => {
    navigate('/email/history');
  };

  const handleSent = (emailResult) => {
    // Navigate back to history with success message
    navigate('/email/history', { 
      state: { 
        message: `Email ${mode === 'edit' ? 'resent' : mode === 'forward' ? 'forwarded' : 'sent'} successfully!`,
        type: 'success'
      }
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Parrot Email</h1>
        <p className="text-gray-600 mt-2">Create and send emails to your recipients</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <EmailComposer
          templateId={templateId}
          emailData={emailData}
          mode={mode}
          onClose={handleClose}
          onSent={handleSent}
          isFullPage={true}
        />
      </div>
    </div>
  );
};

export default EmailComposerPage;